import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

import { SharedService } from '../../../../../shared/shared.service';
import { VehicleService } from '../../vehicle.service';
import { VehicleArry } from './vehicleArry';
import notify from 'devextreme/ui/notify';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';


@Component({
  selector: 'app-vehicle-edit',
  templateUrl: './vehicle-edit.component.html',
  styleUrls: ['./vehicle-edit.component.css']
})
export class VehicleEditComponent implements OnInit {

  popupVisible = false;
  dataSource: any;
  sessionId = sessionStorage.getItem('com-session-id');
  vehicleId = sessionStorage.getItem('vehicle-id');

  constructor(
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public vehicle: VehicleService,
    private location: Location,
    private usefultoolsservice: UsefulToolsService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    if (this.vehicle.vehicle === 1) {
      this.sharedService.loadingActive = true;
      this.dataSource = {Make: '', Model: '', RegistrationNumber: '', Year: null, Fullname: ''};
      this.sharedService.loadingActive = false;
    } else if (this.vehicle.vehicle === 0) {
      this.sharedService.loadingActive = true;
      const postThis = { SessionID: sessionStorage.getItem('com-session-id'), ID: 'All_Vehicles', Parameters: '' };
      this.httpClient.post<any>(`${this.sharedService.URL}/utData`, postThis).subscribe(Response => {
        this.dataSource = Response.utData_response.list;
        this.dataSource = this.dataSource.filter(item => item.Id == this.vehicleId)[0];
        this.sharedService.loadingActive = false;
      });
    } else {
      this.sharedService.loadingActive = false;
      this.location.back();
    }
  }

  onFormSubmit() {

    // validation

    if (this.dataSource.Model === '' || this.dataSource.Model === null) {
      this.usefultoolsservice.notify('error', `Required Model`);
      return;
    }
    if (this.dataSource.Make === '' || this.dataSource.Make === null) {
      this.usefultoolsservice.notify('error', `Required Make`);
      return;
    }
    if (this.dataSource.Year === '' || this.dataSource.Year === null) {
      this.usefultoolsservice.notify('error', `Required Year`);
      return;
    }
    if (isNaN(this.dataSource.Year) === true) {
      this.usefultoolsservice.notify('error', `Year must be numeric`);
      return;
    }
    if (this.dataSource.Year > new Date().getFullYear() || this.dataSource.Year < 1900) {
      this.usefultoolsservice.notify('error', `Year can only be between 1900 - ${new Date().getFullYear()}`);
      return;
    }
    if (this.dataSource.RegistrationNumber === '' || this.dataSource.RegistrationNumber === null) {
      this.usefultoolsservice.notify('error', `Required RegistrationNumber`);
      return;
    }


      if (this.vehicle.vehicle === 1) {
        const postThis = {
          SessionID: sessionStorage.getItem('com-session-id'),
          Vehicle: [{
            'Model': this.dataSource.Model,
            'Make': this.dataSource.Make,
            'Year': this.dataSource.Year,
            'RegistrationNumber': this.dataSource.RegistrationNumber
      }]
        };
        this.httpClient.post<any>(`${this.sharedService.URL}/dbVehicle`, postThis).subscribe(Response => {
          if (Response.dbVehicle_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbVehicle_response.ServiceResults[0].RESULTACTION === 'insert') {
            this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
            this.location.back();
          } else {
            this.usefultoolsservice.notify('error', `Error: ${Response.dbVehicle_response.ServiceResults[0].ERRORDESCRIPTION}`);
            this.location.back();
          }
        });
      } else if ( this.vehicle.vehicle === 0) {
        const postThis = {
          SessionID: sessionStorage.getItem('com-session-id'),
          Vehicle: [{
            'Id': this.dataSource.Id,
            'Model': this.dataSource.Model,
            'Make': this.dataSource.Make,
            'Year': this.dataSource.Year,
            'RegistrationNumber': this.dataSource.RegistrationNumber
      }]
        };
        this.httpClient.put<any>(`${this.sharedService.URL}/dbVehicle`, postThis).subscribe(Response => {
          if (Response.dbVehicle_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbVehicle_response.ServiceResults[0].RESULTACTION === 'updateinsert') {
            this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
            this.location.back();
          } else {
            this.usefultoolsservice.notify('error', `Error: ${Response.dbVehicle_response.ServiceResults[0].ERRORDESCRIPTION}`);
          }
        });
      }
  }

  delete() {
    // tslint:disable-next-line:max-line-length
    this.httpClient.delete<any>(`${this.sharedService.URL}/dbVehicle?SessionID=${this.sessionId}&id=${this.vehicleId}`).subscribe(Response => {
      if (Response.dbVehicle_response.ServiceResults[0].hasOwnProperty('ERRORDESCRIPTION')) {
        if (Response.dbVehicle_response.ServiceResults[0].ERRORDESCRIPTION === 'Error occured Deleting the record 30] Entry Not Found [0]') {
          notify('Cannot delete this record. It is linked to other records in the database.', 'error', 5000);
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbVehicle_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
        this.popupVisible = false;
      } else {
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
        this.location.back();
      }
    });
  }

  toggle(data) {
    if (data === true) {
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }

}
